import {currentAuth, type AuthSnapshot} from './auth.js';
import {ensureEnterpriseModalStyles} from './admin-enterprise-styles.js';
import {renderAuth} from './pages.js';
import {renderAdminApp} from './admin-app.js';

const root = document.querySelector<HTMLElement>('#root');
if (!root) throw new Error('管理端根节点不存在');
document.documentElement.classList.add('admin-page');
ensureEnterpriseModalStyles();

function isAdmin(value: AuthSnapshot | null): value is AuthSnapshot {
  return Boolean(value?.user?.id && value.organization?.id && ['super_admin', 'operator'].includes(value.role));
}

async function render(): Promise<void> {
  const auth = await currentAuth();
  if (isAdmin(auth)) {
    await renderAdminApp(root!, auth);
    return;
  }
  if (auth) {
    root!.innerHTML = '<main class="fatal-page"><section class="fatal-card"><h1>无权访问后台控制台</h1><p>当前账号没有管理员或运营人员权限。</p><a class="btn-secondary" href="/login">重新登录</a></section></main>';
    return;
  }
  renderAuth(root!, 'login', 'admin');
}

window.addEventListener('popstate', () => void render());
void render().catch((error) => {
  root!.innerHTML = `<main class="fatal-page"><section class="fatal-card"><h1>管理端暂时无法加载</h1><p>${String(error instanceof Error ? error.message : error)}</p><a class="btn-secondary" href="/login">重新登录</a></section></main>`;
});
